import { Guide } from "@agp/shared.user-app/entity";
import { PlusIcon } from "lucide-react";
import { useEffect, useState } from "react";
import { MonotoneGuideListThumbnail } from "./monotone-guide-list-thumbnail";
import PlayingAnimation from "../../../components/playing-animation";

type MonotoneGuideListItemProps = {
  guide: Guide;
  onClickGuide: (guide: Guide) => void;
  onClickPlusIcon: (guide: Guide) => void;
  isSelected?: boolean;
  isListening?: boolean;
};

export const MonotoneGuideListItem = (props: MonotoneGuideListItemProps) => {
  const [duration, setDuration] = useState<number | null>(null);

  useEffect(() => {
    if (props.guide.audioUrl) {
      const audio = new Audio(props.guide.audioUrl);
      audio.addEventListener("loadedmetadata", () => {
        setDuration(audio.duration);
      });
      audio.addEventListener("error", () => {
        setDuration(null);
      });
    }
  }, [props.guide.audioUrl]);

  const formatDuration = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    return `${mins} min`;
  };
  return (
    <div
      onClick={() => props.onClickGuide(props.guide)}
      className={"cursor-pointer flex items-center p-2"}
    >
      <div
        className={
          "w-[60px] h-[60px] rounded-2xl flex justify-center items-center flex-shrink-0 overflow-hidden"
        }
      >
        {props.guide.smallThumbnailUrl ? (
          <img
            src={props.guide.smallThumbnailUrl}
            alt={props.guide.name}
            className="w-full h-full object-cover rounded-2xl"
          />
        ) : (
          <MonotoneGuideListThumbnail
            trackNumber={props.guide.trackNumber}
            className="w-full h-full"
          />
        )}
      </div>
      <div className={"flex-grow flex items-center px-6 gap-3"}>
        {props.isSelected && (
          <PlayingAnimation
            active={props.isListening ?? false}
            color={"gray"}
          />
        )}
        <div>
          <div className={"text-[14px] text-gray-800"}>
            <div className="truncate whitespace-pre-wrap">
              {props.guide.name}
            </div>
          </div>
          <div className={"text-[11pt] text-gray-600"}>
            {duration ? formatDuration(duration) : "Loading..."}
          </div>
        </div>
      </div>
      <div
        className={"text-gray-500"}
        onClick={() => props.onClickPlusIcon(props.guide)}
      >
        <PlusIcon size={30} />
      </div>
    </div>
  );
};
